<template>
  <highcharts :options="chartOptions"></highcharts>
</template>
<script>
export default {
  name: 'DonutChart',
  props: ['data', 'series_title'],

  data () {
    return {
    }
  },
  computed: {
    chartOptions: function () {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: 210,
          marginBottom: 40
        },
        title: {
          text: this.series_title,
          align: 'center',
          verticalAlign: 'top',
          y: 20
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false
            },
            startAngle: -90,
            endAngle: 270,
            center: ['50%', '75%'],
            size: '110%'
          }
        },
        series: [{
          type: 'pie',
          name: this.series_title,
          innerSize: '60%',
          data: this.data
        }]
      }
    }
  },

  methods: {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/DonutChart.vue